module.exports = __webpack_public_path__ + "img/attack_goldenlotus.07ee142e.png";